import { render, staticRenderFns } from "./RoomTypeDialog.vue?vue&type=template&id=3cb66adc"
import script from "./RoomTypeDialog.vue?vue&type=script&lang=ts"
export * from "./RoomTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports